import { ScrollPageTop } from '@kocsistem/oneframe-react-bundle';
import React, { useEffect } from 'react';
import { isMobile, isTablet, isMacOs } from 'react-device-detect';
import { useDispatch } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';

import Layout1 from './components/layouts/layout1';
import Layout2 from './components/layouts/layout2';
// import { getAllEmployees, getDepartments, getTutorial, getUserTeams } from './store/features/moments/momentsSlice';
// import { getLocalStorageItem } from './core/utility';
import SendMailToProfile from './components/sendMailToProfile';
import { getStoredLanguage } from './core/utility/translate';
import history from './history';
import LanguageContext from './language-context';
import Login from './pages/account/login';
import Logout from './pages/account/logout';
import Kvkk from './pages/kvkk';
import LoginFailedPage from './pages/loginFailedPage';
import MomentReports from './pages/moment-reports';
import Moments from './pages/moments';
import Profile from './pages/profile';
// import { useAppSelector } from './store';
import { getLocalizationWords } from './store/features/localization/localizationSlice';

const App = () => {
    const [language, setLanguage] = React.useState(getStoredLanguage());
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isMobile && !isTablet) {
            document.querySelector('body').classList.add('not-touch-device');
        }
        if (!isMacOs) {
            document.querySelector('body').classList.add('not-mac-device');
        }
        dispatch(getLocalizationWords());
    }, []);

    return (
        <>
            <LanguageContext.Provider value={{ language, setLanguage }}>
                <Router history={history}>
                    <ScrollPageTop scrollElement="root">
                        <Switch>
                            <Layout2 exact path="/" component={Moments} />
                            <Layout1 exact path="/profile" component={Profile} />
                            <Layout1 exact path="/kvkk" component={Kvkk} />
                            <Route exact path="/autWarning" component={LoginFailedPage} />
                            <Route exact path="/accounts/login" component={Login} />
                            <Route exact path="/accounts/logout" component={Logout} />
                            <Route exact path="/send-mail-to-profile/:code" component={SendMailToProfile} />
                            <Route exact path="/send-mail-to-profile-by-user/:code" component={SendMailToProfile} />
                            <Route exact path="/moment-reports" component={MomentReports} />
                            <Route exact path="/moment-reports/:id" component={MomentReports} />
                            {/* <Route exact path="/accounts/register" component={Register} /> */}
                            {/* <Route exact path="/accounts/forgot-password" component={ForgotPasswordComponent} />
                            <Route exact path="/accounts/new-password" component={NewPasswordComponent} />
                            <Route exact path="/accounts/login-2fa" component={Login2FaComponent} /> */}
                            {/* <Layout1Routes exact path="/" component={Dashboard} /> */}
                        </Switch>
                    </ScrollPageTop>
                </Router>
            </LanguageContext.Provider>
        </>
    );
};

export default App;
